export default __webpack_public_path__ + "static/media/death-cover-icon.3255f0d5.svg";